import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=722cc24b&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=722cc24b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722cc24b",
  null
  
)

export default component.exports